<template>
  <div class="status-list scroll-styling rounded-lg  relative">
    <div class="relative overflow-x-auto">
      <div class="tsor-content-block">
        <h3 class="mt-20 tsor-title font-semibold text-lg light text-center margin-bt-30">
          {{ title }}
        </h3>
        <div class="flex-center fl-start top">
          <div ref="contentLeftBlock" class="inl-75 tsorLeftContent">
            <!-- player -->
            <div
              v-if="videoFile && !isLoadingData"
              class="inl-100 video-block m-auto mt-10 mb-10 text-center"
            >
              <video-player
                :src="videoFile"
                controls
                :loop="false"
                :volume="0.6"
                :width="contentLeftBlock"
                :height="600"
              />
            </div>

            <!-- video edit -->
            <div v-if="(!videoFile && canEdit) || videoUUID && canEdit">
              <div class="max-w-full mb-5 mt-5 inl-99">
                <label
                  class="flex justify-center w-full h-32 px-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none"
                >
                  <span class="flex flex-col items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="margin-t-14 w-6 h-6 text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      />
                    </svg>
                    <span
                      v-if="!videoFileName && !videoUUID"
                      class="font-medium text-gray-600"
                    >
                      <span>
                        Добавить видео материал
                        <span class="text-blue-600 underline">Выбрать</span>
                      </span>
                    </span>
                    
                    <div 
                      class="flex flex-col">
                      <span v-if="!videoFileName && videoUUID"
                        class="font-medium text-gray-600">
                        <span>
                          Заменить видео
                          <span class="text-blue-600 underline">Выбрать</span>
                        </span>
                      </span>
                      <button
                        v-if="videoUUID"
                        @click="deleteVideo" 
                        class="margin-t-15 bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
                        Удалить
                      </button>
                    </div>

                    <div
                      v-if="videoFileName"
                      class="font-medium text-gray-600"
                    >
                      {{ videoFileName }}
                    </div>
                  </span>
                  <input
                    @change="onUploadVideo"
                    ref="videoFile"
                    accept="video/mp4,video/x-m4v,video/*"
                    type="file"
                    name="file_upload"
                    class="hidden"
                  />
                </label>
              </div>

              <div v-if="videoFileName" class="inl-20 mb-3">
                <button
                  @click="uploadVideo"
                  class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  style="width: 100%"
                >
                  <span>Загрузить</span>
                </button>
              </div>
            </div>

            <nav
              style="width: auto; display: inline-block"
              class="margin-t-35 inl-blocks Breadcrumbs flex px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
              aria-label="Breadcrumb"
            >
              <ol class="inline-flex items-center space-x-1 md:space-x-3">
                <li class="inline-flex items-center">
                  <router-link
                    :to="{ query: { tab: 'isContent' } }"
                    class="pointer inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
                  >
                    <span
                      :style="{
                        fontWeight: contentKey == 'isContent' ? 900 : 400,
                      }"
                      >Конспект</span
                    >
                  </router-link>
                </li>
                <li class="inline-flex items-center">
                  <router-link
                    :to="{ query: { tab: 'isFiles' } }"
                    class="pointer inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
                  >
                    <span
                      :style="{
                        fontWeight: contentKey == 'isFiles' ? 900 : 400,
                      }"
                      >Материалы</span
                    >
                  </router-link>
                </li>
                <li
                  v-if="isTest || canEdit"
                  class="inline-flex items-center">
                  <router-link
                    :to="{ query: { tab: 'isQuestion' } }"
                    class="pointer inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
                  >
                    <span
                      :style="{
                        fontWeight: contentKey == 'isQuestion' ? 900 : 400,
                      }"
                      >Тест</span
                    >
                  </router-link>
                </li>
                <li class="inline-flex items-center">
                  <router-link
                    :to="{ query: { tab: 'isLabWork' } }"
                    class="pointer inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
                  >
                    <span
                      :style="{
                        fontWeight: contentKey == 'isLabWork' ? 900 : 400,
                      }"
                      >Лабораторные работы</span
                    >
                  </router-link>
                </li>
              </ol>
            </nav>

            <div
              v-for="(el, ind) in contentKeys"
              :key="ind"
              class="mt-5 text-center tsor-content inl-98"
            >
              <div v-if="el == 'isContent' && el == contentKey">
                <div v-if="canEdit">
                  <div class="flex-center">
                    <div></div>
                    <div class="inl-20 mb-5">
                      <button
                        @click="changeText"
                        class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        style="width: 100%"
                      >
                        Обновить
                      </button>
                    </div>
                  </div>
                  <VueEditor v-model="content" />
                </div>
                <div 
                  class="text-left"
                  v-else v-html="content"></div>
              </div>
              <div v-else-if="el == 'isFiles' && el == contentKey">
                <TsorFiles 
                  :canEdit="canEdit"
                  :contentLeftBlock="contentLeftBlock"
                  :contentFiles="contentFiles"
                  :themeUUID="themeUUID"
                />
              </div>
              <div v-else-if="(
                isTest && el == 'isQuestion' && el == contentKey
              ) || (el == 'isQuestion' && el == contentKey && canEdit)">
                <TsorQuestions
                  v-if="!canEdit"
                  :key="$route.fullPath"
                  :questionUUID="el.uuid"
                  @active="onChildActive"
                  />
                <TsorQuestionsEdit
                  :canEdit="canEdit"
                  v-else
                  :key="$route.fullPath + '_edit'"
                  :questionUUID="el.uuid"
                  @active="onChildActive"
                />
              </div>
              <div v-else-if="el == 'isLabWork' && el == contentKey">
                <LabWorksList
                  v-if="!canEdit"
                  :themeUUID="themeUUID"
                  :canEdit="canEdit"
                />
                <LabWorksEdit
                  v-else
                  :themeUUID="themeUUID"
                  @active="onChildActive"
                />
              </div>
            </div>
          </div>

          <div class="inl-25 h-100-p tsor-nav-content">
            <div
              class="mt-10 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
            >
              <div
                v-for="(el, ind) in nav_list_data"
                :key="ind"
                :style="{
                  backgroundColor: !canEdit && user?.role?.key !== 2 && userLvl < el.lvl ? 'rgba(0, 0, 0,  0.5)' : 'transparent',
                  borderRadius: '10px',
                }"
                @click="() => {
                  goToTsor(el);
                }"
                class="nav-item pl-3 pt-3 pb-3 text-base light inl-100 border border-gray-200">
                <span v-if="ind != currentTehemeIndex">{{ el.title }}</span>
                <b v-else>{{ el.title }}</b>
                <span
                  v-if="canEdit && el.is_confirmed === false"
                  class="ml-2 text-xs font-medium px-2 py-0.5 rounded bg-red-100 text-red-800"
                >
                  Неактивна
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-10"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { HEADERS_TOKEN_JSON, HEADERS_TOKEN_FILE, API_CLIENT } from "@/const/uri";
import { VideoPlayer } from "@videojs-player/vue";
import { MEDIA_HOST } from "@/const/uri.dev";
import { VueEditor } from "vue3-editor";
import { mapActions, mapState } from "vuex";

import TsorQuestions from '@/components/Tsor/TsorQuestions.vue';
import TsorQuestionsEdit from '@/components/Tsor/TsorQuestionsEdit.vue';
import TsorFiles from '@/components/Tsor/TsorFiles.vue';
import LabWorksList from '@/components/Tsor/LabWorksList.vue';
import LabWorksEdit from '@/components/Tsor/LabWorksEdit.vue';

export default {
  components: {
    TsorQuestions, TsorQuestionsEdit,
    TsorFiles, LabWorksList, LabWorksEdit,
    VideoPlayer, VueEditor,
  },
  data() {
    return {
      isLoadingData: true,
      isLoading: true,
      htmlContent: null,
      videoFormData: null,
      videoFileName: null,
      title: null,
      content: null,
      subject: {},
      nav_list_data: [],
      currentTehemeIndex: 0,
      currentId: null,
      contentLeftBlock: 0,
      mediaHost: MEDIA_HOST,
      allFiles: [],
      videoUUID: null,
      videoFile: null,
      contentFiles: [],
      questions: [],
      contentKey: this.$route?.query?.tab || "isContent",
      contentKeys: ["isContent", "isFiles", "isQuestion", "isLabWork"],
      canEdit: false,
      isTest: false,
      userLvl: 0,
      isChildActive: false,
      isRollingBack: false,
    };
  },
  computed: {
    ...mapState(['user',]),
    themeUUID() {
      return this.$route.params.themeUUID;
    },
  },
  mounted() {
    this.getData();
    const contentLeftBlock = this.$refs.contentLeftBlock.offsetWidth;
    this.contentLeftBlock = contentLeftBlock;
  },
  beforeRouteLeave(to, from, next) {
    if (this.isChildActive) {
      if (confirm('Вы уверены, что хотите покинуть эту страницу? Несохранённые данные будут потеряны.')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  watch: {
    $route(to, from) {
      const newTab = to.query.tab || "isContent";
      const oldTab = from.query.tab || "isContent";
      // Пропускаем проверку при откате вкладки
      if (this.isRollingBack) {
        this.isRollingBack = false;
        this.contentKey = newTab;
        return;
      }
      // При смене вкладки — проверить, не активен ли дочерний компонент
      if (newTab !== oldTab && this.isChildActive) {
        if (!confirm('Вы уверены, что хотите выйти? Несохранённые данные будут потеряны.')) {
          // Откатить на предыдущую вкладку
          this.isRollingBack = true;
          this.$router.replace({ query: { tab: oldTab } });
          return;
        }
        this.isChildActive = false;
      }
      this.contentKey = newTab;
      if (to.params.themeUUID !== from.params.themeUUID) {
        this.isLoadingData = true;
        this.getData();
        const contentLeftBlock = this.$refs.contentLeftBlock.offsetWidth;
        this.contentLeftBlock = contentLeftBlock;
      }
    },
  },
  methods: {
    ...mapActions(["toggleAlert"]),
    onChildActive(val) {
      this.isChildActive = val;
    },
    goToTsor(el) {
      // Эксперты (role 2) могут просматривать все темы
      const isExpert = this.user?.role?.key === 2;
      if(!this.canEdit && !isExpert && this.userLvl < el.lvl) {
        this.toggleAlert({
          message: "Уровень не достаточен",
          isError: true,
        });
      } else {
        this.$router.push({
          name: 'ClienntTsorTheme',
          params: {
            uuid: this.$route.params.uuid,
            themeUUID: el.uuid,
          },
        });
      }
    },
    delteTsorFile(ind) {
      this.contentFiles.splice(ind, 1);
    },
    updateTsorFile(data) {
      this.setFiles([data]);
    },
    onUploadVideo(e) {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        this.videoFileName = selectedFile.name;
      } else {
        this.videoFileName = "";
      }
    },
    setFiles(fileData) {
      fileData.forEach((el) => {
        const file = `${this.mediaHost}${el.file}`;
        if (el.is_video) {
          this.videoFile = file;
          this.videoUUID = el.uuid;
        }
        if (el.is_file) {
          const splitVals = el.name.split("/");
          const val = splitVals[splitVals.length - 1];
          this.contentFiles.push({
            id: el.id,
            uuid: el.uuid,
            file: file,
            name: val,
            ext: el.ext,
          });
        }
      });
    },
    getCurrentTheme() {
      for (let index = 0; index < this.nav_list_data.length; index++) {
        if (this.nav_list_data[index].uuid == this.currentId) {
          this.currentTehemeIndex = index;
          break;
        }
      }
    },
    async changeText() {
      await axios({
        method: "PUT",
        url: API_CLIENT.tsorDetail + this.$route.params.themeUUID + "/content/",
        headers: HEADERS_TOKEN_JSON(),
        data: {
          content: this.content,
        },
      })
        .then((e) => {
          console.log(e);
          this.toggleAlert({
            message: "Контент успешно обновлен",
            isError: false,
          });
          console.log(e);
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    async deleteVideo() { 
      await axios({
        method: "DELETE",
        url: API_CLIENT.tsorDetail + "remove-video/",
        headers: HEADERS_TOKEN_JSON(),
        params: {
          video_uuid: this.videoUUID,
        },
      })
        .then(() => {
          this.videoUUID = null;
          this.videoFile = null;
          this.videoFileName = null;
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    async uploadVideo() {
      this.isLoading = true;
      const file = this.$refs.videoFile.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("tsor", this.$route.params.themeUUID);
      let url = "";
      if (this.videoUUID) {
        url = API_CLIENT.tsorDetail + this.videoUUID + "/video/";
      } else {
        url = API_CLIENT.tsorDetailVideo;
      }
      await axios({
        method: !this.videoUUID ? "POST" : "PUT",
        url: url,
        headers: HEADERS_TOKEN_FILE(),
        data: formData,
      })
        .then((e) => {
          this.videoUUID = e.data.data.uuid;
          this.videoFile = `${this.mediaHost}${e.data.data.file}`;
          this.isLoading = false;
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    async getData() {
      await axios({
        method: "GET",
        url: API_CLIENT.tsorDetail + this.$route.params.themeUUID + "/",
        headers: HEADERS_TOKEN_JSON(),
      })
        .then((e) => {
          this.userLvl = e.data.data.user_lvl;
          this.nav_list_data = e.data.data.nav_list_data;
          this.title = e.data.data.tsor.title;
          this.isTest = e.data.data.tsor.is_test;
          this.currentId = e.data.data.tsor.uuid;
          this.content = e.data.data.tsor.content;
          this.questions = e.data.data.tsor.tsor_questions;
          this.canEdit = e.data.data.can_edit || false;
          this.isLoadingData = false;
          this.videoFile = null
          this.videoFileName = null;
          this.videoUUID = null;
          this.contentFiles = [];
          this.setFiles(e.data.data.tsor.tsor_files);
          this.getCurrentTheme();
        })
        .catch(function (e) {
          console.log(e);
        });
    },
  },
  props: {
    tsorId: {},
  },
};
</script>

<style></style>